import * as React from 'react';
import { FelaComponent } from '@filou/core';
var Spacer = function () { return (React.createElement(FelaComponent, { style: {
        flex: 1
    } })); };
export default Spacer;
//# sourceMappingURL=index.js.map